import { render, staticRenderFns } from "./CreateRefinement.vue?vue&type=template&id=9676ecda&"
import script from "./CreateRefinement.vue?vue&type=script&lang=js&"
export * from "./CreateRefinement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports